import { store } from '../store/store';
import { ThemeMode } from '../schema/ThemeMode';

/**
 * Returns themeMode value
 */
export const getThemeMode = (): ThemeMode => store.themeMode;
